import axios from 'axios';

export const getAllData = (latitude, longitude) => {
	return axios.get('https://garbagemon.000webhostapp.com/fetch_api.php?latitude_d=' + latitude + '&longitude_d=' + longitude);
};

export const getLocation = () => {
	return axios.get('http://ip-api.com/json');
};
